import React, { useState } from 'react';
import { Box, ClickAwayListener, IconButton, Toolbar } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import logoAiVoice from '@src/assets/logo/logo-AiVoice-new.svg';
import { StyledNewAppBar } from './index.style';
import UserInfo from './SidebarNew/UserInfo';
import MobileProfileAction from './SidebarNew/MobileProfileAction';

const NewNavbar = ({ handleOpenSidebar, location }) => {
  const [isProfileActionOpen, setProfileActionOpen] = useState(false);
  const handleClickProfile = () => {
    setProfileActionOpen((prev) => !prev);
  };

  const handleClickAway = () => {
    if (isProfileActionOpen) {
      setProfileActionOpen(false);
    }
  };

  return (
    <StyledNewAppBar>
      <Toolbar className="container">
        <IconButton color="secondary" onClick={handleOpenSidebar}>
          <MenuIcon />
        </IconButton>
        <img
          src={logoAiVoice}
          alt="vbee tts logo"
          className="logo-img"
          height={34}
        />
        <ClickAwayListener onClickAway={handleClickAway}>
          <div>
            <Box onClick={handleClickProfile}>
              <UserInfo ipLocation={location} isMobile />
            </Box>
            {isProfileActionOpen && (
              <MobileProfileAction
                onShowProfile={handleClickProfile}
                location={location}
              />
            )}
          </div>
        </ClickAwayListener>
      </Toolbar>
    </StyledNewAppBar>
  );
};

export default NewNavbar;
